import { render, staticRenderFns } from "./allFiles.vue?vue&type=template&id=54a07499&"
import script from "./allFiles.vue?vue&type=script&lang=js&"
export * from "./allFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports